import React, { useContext } from 'react';
import { ProgressionBar } from '../../../progression-bar/index.js';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext.js';
import { ExerciseDialogsContext } from '../../../../context/ExerciseDialogsContext.js';
import { ModalDialog, Dialog } from '../../../dialog/index.js';
import { Button } from '../../../button/index.js';
import { getScoreAsPercentage } from '../../util/score-utils.js';
import { ExerciseManagerContext } from '../../contexts/ExerciseManagerContext.js';

const ExerciseResumeDialog = ({ onClose, onResume, onRestart, result }) => {
    const translations = useContext(ExerciseTranslationsContext);
    const dialogContext = useContext(ExerciseDialogsContext);
    const percentage = getScoreAsPercentage(result.score.achieved, result.score.achievable);
    const { showScore } = useContext(ExerciseManagerContext);
    return (React.createElement(ModalDialog, { id: 'exercise-resume-dialog', onClose: onClose, closeTitle: translations.closeDialog, closeViaEscape: true, className: 'exercise-dialogs' },
        React.createElement(Dialog.Header, { title: translations.exerciseResumeDialog.title, startAdornment: dialogContext.header.iconClassName ? (React.createElement("i", { className: dialogContext.header.iconClassName, role: 'img' })) : (undefined) }),
        React.createElement(Dialog.Body, { "data-testid": 'exercise-resume-body' },
            showScore && (React.createElement("p", null,
                translations.exerciseResumeDialog.scorePrefix,
                React.createElement("b", null,
                    percentage,
                    "%"),
                ".")),
            onRestart ? (React.createElement(React.Fragment, null,
                React.createElement("p", null, translations.exerciseResumeDialog.message.p1.restartable),
                React.createElement("p", null, translations.exerciseResumeDialog.message.p2))) : (React.createElement("p", null, translations.exerciseResumeDialog.message.p1.nonRestartable)),
            !showScore && React.createElement("p", null, translations.exerciseResumeDialog.result),
            React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar })),
        React.createElement(Dialog.Footer, { "data-testid": 'exercise-resume-footer' },
            React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exerciseResumeDialog.buttons.cancel),
            onRestart && (React.createElement(Button, { variant: 'secondary', onClick: onRestart }, translations.exerciseResumeDialog.buttons.restart)),
            onResume && (React.createElement(Button, { variant: 'primary', onClick: onResume }, translations.exerciseResumeDialog.buttons.resume)))));
};

export { ExerciseResumeDialog };
